module.exports = __webpack_public_path__ + "assets/img/group-logo.68a62105.png";